export const DEFAULT_CENTER = { lat: 48.8534, lng: 2.3488 }

export const DEFAULT_MAP_OPTIONS: L.MapOptions = {
  center: DEFAULT_CENTER,
  zoom: 10,
  zoomControl: false,
}
